import { withPrefix } from 'gatsby-link';
import React, { useState } from 'react';

import { ShareButtons } from '../ShareButtons';
import styles from './HeroButtons.styles';

const HeroButtons = ({ data, shareText }) => {
  const { btnText, btnIcon, btnIconHover, btnList } = data;
  const [open, setOpen] = useState(true);
  return (
    <div css={styles(btnIcon, btnIconHover)}>
      <div className="heroButtons">
        <div
          className={`btn-menu ${open ? 'closed' : ''}`}
          onMouseEnter={() => setOpen(!open)}
          onMouseLeave={() => setOpen(!open)}
        >
          <button className="downloadBtn-container">
            <p className="btnText">{btnText}</p>
            <div className="btnIcon" />
          </button>
          <ul className="btn-list">
            {btnList.map((item) => (
              <a href={withPrefix(item.btnHref)} download className="link-wrapper">
                <li key={item.btnItem} className="btn-item">
                  {item.btnItem}
                </li>
              </a>
            ))}
          </ul>
        </div>
        <ShareButtons text={shareText} />
      </div>
    </div>
  );
};

export default HeroButtons;
